import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function MangoLassi() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section className="recipe-hero-anim" style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          padding: "60px 0 40px 0"
        }}>
          <h1 className="recipe-title-anim" style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Mango Lassi</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 16 }}>A sweet, creamy mango drink.</p>
          <span className="season-badge season-summer">☀️ Best in Summer</span>
          <ImageWithFallback src="/Mango_lassi.jpg" alt="Mango Lassi" className="recipe-image-anim" style={{ width: 340, borderRadius: 24, boxShadow: "0 4px 32px rgba(0,0,0,0.10)", marginBottom: 24, marginTop: 20 }} />
          <div style={{ fontSize: "1.1rem", color: "#555", maxWidth: 600, textAlign: "center" }}>
            Try this delicious mango lassi recipe!
          </div>
          <div className="recipe-columns-anim" style={{
            fontSize: "1.1rem",
            color: "#555",
            maxWidth: 600,
            textAlign: "center",
            marginTop: 24
          }}>
            <h2 style={{ fontSize: "1.5rem", fontWeight: "bold", marginBottom: 12 }}>Recipe</h2>
            <ul className="ingredient-list" style={{ textAlign: "left", marginBottom: 16 }}>
              <li>1 cup ripe mango pulp</li>
              <li>1/2 cup plain yogurt</li>
              <li>2 tablespoons sugar</li>
              <li>Ice cubes</li>
            </ul>
            <p style={{ textAlign: "left" }}>
              Blend mango pulp, yogurt, and sugar until smooth. Add ice cubes and blend again. Serve chilled!
            </p>
          </div>
          <div style={{ maxWidth: 600, width: "100%", marginTop: 32, display: "flex", flexDirection: "column", gap: 24 }}>
            <div className="chef-tips-box" style={{ background: "#f8f9fa", padding: 20, borderRadius: 12, textAlign: "left" }}>
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Use full-fat, thick yogurt for the creamiest texture — thin yogurt makes a watery lassi.</li>
                <li>Choose a sweet, fibreless mango variety like Alphonso for the smoothest pulp.</li>
                <li>Chill the yogurt and mango beforehand so you don't have to over-dilute with ice.</li>
                <li>A pinch of cardamom powder or a few strands of saffron take this to the next level.</li>
                <li>Blend just until smooth — over-blending can make yogurt-based drinks slightly runny.</li>
              </ul>
            </div>
            <div className="health-benefits-box" style={{ background: "#eef9f0", padding: 20, borderRadius: 12, textAlign: "left" }}>
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Yogurt is a good source of probiotics that support gut and digestive health.</li>
                <li>Mango adds vitamin A and C, both important for skin and immunity.</li>
                <li>The calcium and protein in yogurt help keep bones and muscles strong.</li>
                <li>A cooling, filling drink that can double as a light snack on a hot day.</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default MangoLassi;
